module.exports = "/_next/static/images/ico-sad-2bb4bd47e231e8724453108efa488eb7.svg";